module.exports = __webpack_public_path__ + "img/compliance-lock.7f5f9af1.png";